import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './globals.css';
import { BrowserRouter } from 'react-router-dom';

try {
  if (window !== window.top && window.top && window.top.location.host === window.location.host) {
    window.top.location.href = window.location.href;
  } else if (window !== window.top) {
    console.warn("App is embedded in an iframe from a different domain and cannot break out.");
  }
} catch (e) {
  console.warn("Could not break out of iframe due to cross-origin restrictions:", e);
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
